"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by anania.mikaelyan on 12/7/16.
 */
var ValidationsCalculationsData = /** @class */ (function () {
    function ValidationsCalculationsData(validationErrors, calculationWarnings, data) {
        this.validationErrors = validationErrors;
        this.calculationWarnings = calculationWarnings;
        this.data = data;
    }
    ValidationsCalculationsData.prototype.getValidations = function () {
        return this.validationErrors;
    };
    ValidationsCalculationsData.prototype.getCalculations = function () {
        return this.calculationWarnings;
    };
    ValidationsCalculationsData.prototype.getData = function () {
        return this.data;
    };
    return ValidationsCalculationsData;
}());
exports.ValidationsCalculationsData = ValidationsCalculationsData;
//# sourceMappingURL=validations-calculations-data.model.js.map